<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-row class="fill-height" no-gutters>
          <v-col class="col-12">
            <v-row>
              <v-col class="col-12">
                <v-card-title>
                  <h1 class="primary-color">Upload CVs</h1>
                </v-card-title>
                <VueFileAgent
                  ref="vueFileAgent"
                  v-model="fileRecords"
                  :theme="'list'"
                  :multiple="true"
                  :deletable="true"
                  :meta="true"
                  :disabled="fileReceived"
                  :accept="'.pdf'"
                  :max-size="'10MB'"
                  :editable="false"
                  :help-text="'Select PDF or Word files to upload your CVs (uncompressed)'"
                  :error-text="{
                    type: 'Wrong file extension. Please upload only .pdf files (uncompressed).',
                    size: 'The maximum size per file is 10MB.',
                  }"
                  @select="filesSelected($event)"
                  @beforedelete="onBeforeDelete($event)"
                  @delete="fileDeleted($event)"
                />
              </v-col>
            </v-row>

            <v-alert
              v-if="message"
              class="mt-4"
              outlined
              :color="successfull ? 'success' : 'error'"
              :icon="successfull ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ message }}&nbsp;&nbsp;
            </v-alert>

            <v-row
              class="mb-2 justify-center"
              :class="message ? 'mt-4' : 'mt-0'"
              style="text-align: center"
            >
              <v-col
                :class="{
                  'col-2': $vuetify.breakpoint.smAndUp,
                  'col-6': $vuetify.breakpoint.smAndDown,
                }"
              >
                <template v-if="!loading">
                  <v-btn v-if="!uploadDisactive" class="ok-modal" block @click="upload">
                    Upload {{ fileRecordsForUpload.length }} file/s
                  </v-btn>
                </template>
                <v-btn v-else class="ok-modal" disabled block @click="upload">
                  <v-progress-circular indeterminate size="20" />
                  &nbsp;&nbsp;Uploading
                  {{ fileRecordsForUpload.length }} file/s...
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CandidatesDataService from '@/services/CandidatesDataService';
import utils from '@/utils/utils';

export default {
  name: 'UploadCV',
  data() {
    return {
      fileReceived: false,
      fileRecords: [],
      fileRecordsForUpload: [],
      uploadDisactive: true,
      headersPersonalInformation: [{ text: 'CV', value: 'cv_name' }],
      message: '',
      successfull: false,
      loading: false,
    };
  },
  methods: {
    upload() {
      this.loading = false;
      this.successfull = true;
      this.message = '';
      const candidates = [];
      const cvs = [];

      for (let i = 0; i < this.fileRecordsForUpload.length; i++) {
        candidates.push({
          email: utils.config.defaultEmail,
          fileAssociated: i,
        });
        cvs.push(this.fileRecordsForUpload[i].file);
      }

      if (this.successfull) {
        this.loading = true;
        const formData = new FormData();
        formData.append('candidates', JSON.stringify(candidates));
        cvs.forEach((cv) => {
          formData.append('cvs', cv, cv.name);
        });
        if (this.$socketId !== undefined && this.$socketId !== null && this.$socketId !== '')
          formData.append('socketId', this.$socketId);
        else formData.append('socketId', null);

        CandidatesDataService.upload(formData)
          .then((response) => {
            if (response.status == 202) {
              this.successfull = true;
              this.message = 'CVs successfully uploaded.';
            } else {
              this.successfull = false;
              this.message = 'An error occurred while uploading CVs. Please try again later.';
            }

            this.fileReceived = false;
            this.fileRecords = [];
            this.fileRecordsForUpload = [];
            this.uploadDisactive = true;
            this.loading = false;
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 403) {
              localStorage.removeItem('user');
              this.$router.push('/home');
            } else {
              this.successfull = false;
              this.message = 'An error occurred while uploading CVs. Please try again later.';
              this.fileReceived = false;
              this.fileRecords = [];
              this.fileRecordsForUpload = [];
              this.uploadDisactive = true;
            }

            this.loading = false;
          });
      }
    },
    deleteUploadedFile(fileRecord) {
      this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
    },
    filesSelected(fileRecordsNewlySelected) {
      const validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
      if (validFileRecords.length > 0) {
        this.uploadDisactive = false;
        this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
      } else this.uploadDisactive = true;
    },
    onBeforeDelete(fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
        const k = this.fileRecords.indexOf(fileRecord);
        if (k !== -1) this.fileRecords.splice(k, 1);
      } else this.$refs.vueFileAgent.deleteFileRecord(fileRecord);

      this.uploadDisactive = this.fileRecordsForUpload.length <= 0;
      if (this.fileRecordsForUpload.length <= 0) this.message = '';
    },
    fileDeleted(fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord);

      if (i !== -1) this.fileRecordsForUpload.splice(i, 1);
      else this.deleteUploadedFile(fileRecord);

      this.uploadDisactive = this.fileRecordsForUpload.length <= 0;
      if (this.fileRecordsForUpload.length <= 0) this.message = '';
    },
    checkValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    goCVList() {
      this.$router.push('/candidates');
    },
  },
};
</script>
